import { useState, useEffect, useRef } from 'react';

/**
 * Tracks whether the hero "View Legislator Pack" button is visible in the viewport.
 * When it scrolls out of view, a floating mobile CTA is shown.
 */
export function useFloatingButton(googleDriveUrl: string) {
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [observerInitialized, setObserverInitialized] = useState(false);
  const heroLegislatorButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const button = heroLegislatorButtonRef.current;
    if (!button) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setObserverInitialized(true);
        setShowFloatingButton(!entry.isIntersecting);
      },
      { threshold: 0 },
    );

    observer.observe(button);
    return () => observer.disconnect();
  }, [googleDriveUrl]);

  return { showFloatingButton, observerInitialized, heroLegislatorButtonRef };
}
